import styled from "styled-components";

const NoteTypeLabel = styled.span`
  display: flex;
  align-items: center;
  overflow: visible;
  color: ${props => props.theme.colors.redesign.db100};
  font-weight: 600;
  font-size: 16px;
`;

const FormContainer = styled.div<{ open?: boolean }>`
  padding: 0;
  border-radius: 0 0 8px 8px;
  background: ${props => (props?.open ? props.theme.colors.greys.light4 : props.theme.colors.white)};
  ${props => props.theme.belowBreakpoint} {
    background: ${props => props.theme.colors.white};
  }
`;

const MedicalNoteDateContainer = styled.div`
  flex-direction: row;
  display: flex;
  align-items: center;
  min-height: 46px;
  padding: 0 ${props => props.theme.spacing.S_20};
  padding-top: ${props => props.theme.spacing.S_10};
  box-sizing: border-box;
`;

const SignFirstBadge = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: 12px;
  padding: 4px 8px;

  font-size: 12px;
  font-weight: ${({ theme }) => theme.fontWeight.bold};
  line-height: 16px;
  text-align: center;
  border-radius: 4px;
  color: ${({ theme }) => theme.colors.redesign.b100};
  background: ${({ theme }) => theme.colors.redesign.b10};

  ${props => props.theme.belowBreakpoint} {
    margin-left: 0;
  }
`;

export { NoteTypeLabel, FormContainer, MedicalNoteDateContainer, SignFirstBadge };
